import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsAfter } from "../../dateutil";
import moment from 'moment-timezone';

class AfterDateTimeIn extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      let current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD h:mm a');
      let compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD  h:mm a');
      if (!datesAreEqual(current, compare) && !dateIsAfter(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_AFTER_SPECIFIED_DATE_IN',
          values: { value: validation.value },
          message: `Value should be equal to or after '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default AfterDateTimeIn;
